import React from 'react'

import TitleHero from 'components/slices/TitleHero'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const Intro = ({ content, center, offset, decoration }) => {
  return (
    <div className={cx(css.container)}>
      <TitleHero
        className={cx(css.Intro, { offset })}
        center={center}
        decoration={decoration}
        {...content}
      />
    </div>
  )
}

export default Intro
